(function () {
  function getInventoryQuantity(variants, variantId, defaultInventoryQuantity) {
    if (!variantId) return defaultInventoryQuantity;
    var currentVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
    if (!currentVariant) return defaultInventoryQuantity;
    return currentVariant.inventory_quantity;
  }

  function getSelectedVariantId() {
    var form = document.querySelector('form.product-single__form');
    if (form) {
      var select = form.querySelector('select[name="id"][data-product-select]');
      if (select && select.value) return select.value;
      var input = form.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
    }
    var match = window.location.search.match(/variant=(\d+)/);
    return match ? match[1] : null;
  }

  function normalizeZip(value) {
    var zip = (value || '').trim();
    var m = zip.match(/^(\d{5})(?:-\d{4})?$/);
    return m ? m[1] : '';
  }

  function parseMdYDate(dateStr) {
    var parts = String(dateStr || '').trim().split('/');
    if (parts.length !== 3) return null;
    var month = Number(parts[0]);
    var day = Number(parts[1]);
    var year = Number(parts[2]);
    if (!month || !day || !year) return null;
    return new Date(year, month - 1, day);
  }

  function getActivePreOrderShipDate() {
    var message = document.querySelector('.PreOrder__message');
    if (!message || message.style.display !== 'block') return null;

    var dateStr = window.product_preorder_date || '';
    if (!dateStr) {
      var span = message.querySelector('span');
      dateStr = span ? span.textContent.trim() : '';
    }

    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) return null;
    return dateStr;
  }

  function getPostPreOrderDate(days, shipDateStr) {
    var dateStr = shipDateStr || getActivePreOrderShipDate();
    if (!dateStr) {
      var preOrderNode = document.querySelector('.PreOrder__message span');
      if (!preOrderNode) return null;
      dateStr = preOrderNode.textContent.trim();
    }

    var preOrderDate = parseMdYDate(dateStr);
    if (!preOrderDate) return null;

    preOrderDate.setDate(preOrderDate.getDate() + days);
    return preOrderDate.toLocaleDateString();
  }

  function getESTDay(dateObject) {
    var UTCDay = dateObject.getUTCDay();
    var UTCHours = dateObject.getUTCHours();
    if (UTCHours - 5 >= 0) return UTCDay;
    if (UTCDay === 0) return 6;
    return UTCDay - 1;
  }

  function getESTHours(dateObject) {
    var UTCHours = dateObject.getUTCHours();
    if (UTCHours - 5 >= 0) return UTCHours - 5;
    return 24 - (5 - UTCHours);
  }

  function getHoursLeft(cutoffTime, ESTDay, ESTHours) {
    var fridayCutoffTime = 14;
    if (ESTDay === 1 || ESTDay === 2 || ESTDay === 3) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours;
      return 24 - (ESTHours - cutoffTime);
    }
    if (ESTDay === 4) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours;
      return 24 - (ESTHours - fridayCutoffTime);
    }
    if (ESTDay === 5) {
      if (ESTHours < fridayCutoffTime) return fridayCutoffTime - ESTHours;
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours + 72;
      return 24 - (ESTHours - cutoffTime) + 48;
    }
    if (ESTDay === 6) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours + 48;
      return 24 - (ESTHours - cutoffTime) + 24;
    }
    if (ESTDay === 0) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours + 24;
      return 24 - (ESTHours - cutoffTime);
    }
  }

  function getAdditionalDays(cutoffTime, ESTDay, ESTHours) {
    var fridayCutoffTime = 14;
    if (ESTDay === 1 || ESTDay === 2 || ESTDay === 3 || ESTDay === 4) {
      return ESTHours < cutoffTime ? 0 : 1;
    }
    if (ESTDay === 5) {
      return ESTHours < fridayCutoffTime ? 0 : 3;
    }
    if (ESTDay === 6) {
      return 2;
    }
    if (ESTDay === 0) {
      return 1;
    }
  }

  function getText(dataFromDB) {
    if (!dataFromDB || typeof dataFromDB !== 'object') return '';
    if (dataFromDB.isMilitary) {
      return (
        'APO & FPO addresses are military installations around the globe both international and domestic. ' +
        'Orders to these addresses can only be shipped with the United States Postal Service. ' +
        'Shipping to APO & FPO addresses with USPS can take up to 30 days in transit before receipt. ' +
        'We are unable to expedite this shipping service.'
      );
    }
    if (!dataFromDB.days) return '';

    var days = dataFromDB.days;
    var activeShipDate = getActivePreOrderShipDate();
    if (activeShipDate) {
      var fromPdp = getPostPreOrderDate(days, activeShipDate);
      return fromPdp ? 'Estimated delivery by ' + fromPdp : '';
    }

    if (dataFromDB.isPreOrder) {
      var postPreOrderDate = getPostPreOrderDate(days);
      return postPreOrderDate ? 'Estimated delivery by ' + postPreOrderDate : '';
    }

    var cutoffTime = dataFromDB.cutoffTime + 12;
    var date = new Date();
    var ESTDay = getESTDay(date);
    var ESTHours = getESTHours(date);
    var hoursLeft = getHoursLeft(cutoffTime, ESTDay, ESTHours);
    var additionalDays = getAdditionalDays(cutoffTime, ESTDay, ESTHours);
    date.setDate(date.getDate() + days + additionalDays);
    var deliveryDate = date.toLocaleDateString();
    return 'Order in the next ' + hoursLeft + ' hours for estimated delivery by ' + deliveryDate;
  }

  function main() {
    var componentNode = document.querySelector('.delivery-date');
    if (!componentNode) return;
    if (!window.CustomDB2 || !CustomDB2.DeliveryDate || typeof CustomDB2.DeliveryDate.get !== 'function') return;

    var vendor = componentNode.getAttribute('data-vendor') || '';
    var variantsJsonEl = componentNode.querySelector('.delivery-date__variants-json');
    var variants = [];
    try {
      variants = JSON.parse(variantsJsonEl ? variantsJsonEl.textContent : '[]');
    } catch (e) {}

    var defaultInventoryQuantity =
      parseInt(componentNode.getAttribute('data-default-inventory-quantity'), 10) || 0;
    var selectCountry = componentNode.querySelector('.delivery-date__country');
    var zipField = componentNode.querySelector('.delivery-date__zip-field');
    var inputZIP = componentNode.querySelector('.delivery-date__zip');
    var textEl = componentNode.querySelector('.delivery-date__text');

    var state = { inventoryQuantity: 0, country: '', zip: '' };

    function setText() {
      if (!textEl) return;
      var dataFromDB = CustomDB2.DeliveryDate.get(
        vendor,
        state.inventoryQuantity,
        state.country,
        state.zip
      );
      textEl.innerHTML = getText(dataFromDB);
    }

    function applyInventory(inventoryQuantity) {
      if (!inventoryQuantity) {
        componentNode.style.display = 'none';
        state.inventoryQuantity = 0;
        if (textEl) textEl.innerHTML = '';
        return;
      }
      componentNode.style.display = '';
      state.inventoryQuantity = inventoryQuantity;
      setText();
    }

    function syncVariant(variantId) {
      applyInventory(getInventoryQuantity(variants, variantId, defaultInventoryQuantity));
    }

    function onCountryChange() {
      state.country = selectCountry ? selectCountry.value || '' : '';
      if (state.country !== 'United States') {
        state.zip = '';
        if (inputZIP) inputZIP.value = '';
      } else if (inputZIP) {
        state.zip = normalizeZip(inputZIP.value);
      }
      if (zipField) zipField.style.display = state.country === 'United States' ? 'block' : 'none';
      setText();
    }

    function onZipInput() {
      state.zip = normalizeZip(inputZIP ? inputZIP.value : '');
      setText();
    }

    function onVariantChange(detail) {
      var variant = detail && detail.variant;
      if (variant && variant.id != null) {
        syncVariant(String(variant.id));
        return;
      }
      syncVariant(getSelectedVariantId());
    }

    syncVariant(getSelectedVariantId());

    if (selectCountry) selectCountry.addEventListener('change', onCountryChange);
    if (inputZIP) inputZIP.addEventListener('input', onZipInput);

    var productForm = document.querySelector('form.product-single__form');
    if (productForm) {
      var variantSelect = productForm.querySelector('select[name="id"][data-product-select]');
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          syncVariant(variantSelect.value);
        });
      }
    }

    document.addEventListener('variant:change', function (evt) {
      onVariantChange(evt.detail);
    });

    document.addEventListener('preorder:change', setText);

    var productSection =
      componentNode.closest('[data-product-id]') || document.querySelector('[data-product-id]');
    if (productSection) {
      productSection.addEventListener('variantChange', function (evt) {
        onVariantChange(evt.detail);
      });
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  } catch (e) {}
})();
